import { useMutation } from "@tanstack/react-query";
import { useState, type FormEvent } from "react";
import { Navigate, useNavigate, useSearchParams } from "react-router";
import { api, ErroApi } from "../api/cliente";
import { useDefinirSessao, useSessao } from "../api/sessao";
import type { Sessao } from "../api/tipos";
import { Campo } from "../components/Campos";
import { BotaoTema } from "../components/BotaoTema";
import { CreditosLogin } from "../components/Creditos";
import { Carregando, mensagemDeErro } from "../components/Estados";

/** Só aceita voltar para caminhos internos (evita redirecionar para outro site). */
function destinoSeguro(volta: string | null): string {
  return volta && volta.startsWith("/") && !volta.startsWith("//") ? volta : "/";
}

export function PaginaLogin() {
  const { data: sessao, isPending } = useSessao();
  const [parametros] = useSearchParams();
  const navegar = useNavigate();
  const definirSessao = useDefinirSessao();
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");

  const entrar = useMutation({
    mutationFn: () => api<Sessao>("/auth/login", "POST", { email, senha }),
    onSuccess: (nova) => {
      definirSessao(nova);
      navegar(nova.usuario.deveTrocarSenha ? "/trocar-senha" : destinoSeguro(parametros.get("volta")), {
        replace: true,
      });
    },
  });

  if (isPending) return <Carregando />;
  if (sessao) return <Navigate to={sessao.usuario.deveTrocarSenha ? "/trocar-senha" : "/"} replace />;

  const enviar = (e: FormEvent) => {
    e.preventDefault();
    entrar.mutate();
  };
  const erro = entrar.error;

  return (
    <div className="tela-login">
      <form className="card" onSubmit={enviar}>
        <div className="marca">
          <small>Master Soluti</small>
          <h1>Master PDV Eventos</h1>
        </div>
        {erro && (
          <div className="aviso erro" role="alert">
            {mensagemDeErro(erro)}
          </div>
        )}
        <Campo rotulo="E-mail" erro={erro instanceof ErroApi ? erro.doCampo("email") : undefined}>
          <input
            type="email"
            autoComplete="username"
            inputMode="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Campo>
        <Campo rotulo="Senha">
          <input
            type="password"
            autoComplete="current-password"
            required
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
          />
        </Campo>
        <button className="btn primario largo" type="submit" disabled={entrar.isPending}>
          {entrar.isPending ? "Entrando…" : "Entrar"}
        </button>
      </form>
      <CreditosLogin />
      <BotaoTema className="flutuante" />
    </div>
  );
}
